/**
 * Enumeration of all pages
 */
export enum Page {
    /** Represents the CanvasComponent */
    Startup = "Startup",
    Canvas = "canvas",
    LevelSelector = "level-selector",
    Introduction = "introduction-component",
    Ending = "ending-component",
    PauseMenu = "pause-menu",
    Menu = "Menu",
}
